<template>
  <footer v-if="$route.meta.footer === 1" class="footer">
    <div class="container-fluid">
      <!-- <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Dashboard</router-link>
          </li>
        </ul>
      </nav> -->
      <div class="copyright text-center">
        <router-link :to="{path:'/a/terms'}">Terms And Conditions</router-link>&nbsp;&nbsp;
        <router-link :to="{path:'/a/privacy'}">Privacy Policy</router-link>&nbsp;&nbsp;
        <router-link :to="{path:'/a/refund'}">Refund Policy</router-link>&nbsp;&nbsp;
        <router-link :to="{path:'/a/shipping'}">Shipping Policy</router-link>&nbsp;&nbsp;
        <router-link :to="{path:'/a/contact'}">Contact Us</router-link>&nbsp;&nbsp;<br>
        <!-- <a href="http://sanjeevanidairyfarms.com/privacy-policy/">Privacy Policy</a>&nbsp;&nbsp;<a href="http://sanjeevanidairyfarms.com/refund-cancellation/">Refund Policy</a>&nbsp;&nbsp; --><!-- <a href="http://sanjeevanidairyfarms.com/contact-us/">Contact Us</a><br> -->
        <!-- <a href="https://appurl.io/jm9wszpo">Click To Download App</a><br> -->
        &copy; Sanjeevani Dairy Farms Pvt. Ltd. 2023 . All rights reserved.
        <!-- <i class="fa fa-heart heart"></i> by
        <a href="https://github.com/cristijora" target="_blank">Cristi Jora</a>.
        Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>. -->
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>
.footer{
	padding:0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue